module.exports = __webpack_public_path__ + "img/water4.f3de1dd5.jpg";